import * as React from "react";

// Top-view statue/sculpture on pedestal
function StatueIcon({ color = "#9E9E9E", width = 40, height = 40, name }) {
  return (
    <div style={{ textAlign: "center" }}>
      {name && <p style={{ margin: 0, fontSize: "10px", userSelect: "none" }}>{name}</p>}
      <svg
        viewBox="0 0 100 100"
        height={height}
        width={width}
      >
        {/* Pedestal base - square */}
        <rect x="10" y="10" width="80" height="80" rx="4" fill="#BDBDBD" />
        <rect x="15" y="15" width="70" height="70" rx="3" fill="#E0E0E0" />
        {/* Inner pedestal */}
        <rect x="25" y="25" width="50" height="50" rx="2" fill={color} />
        <rect x="30" y="30" width="40" height="40" rx="2" fill="#757575" />
        {/* Statue shadow/form - abstract top view */}
        <ellipse cx="50" cy="50" rx="15" ry="12" fill="#616161" />
        <circle cx="50" cy="45" r="8" fill="#424242" />
      </svg>
    </div>
  );
}

export default StatueIcon;
